import { Flex as FlexBase } from "@rebass/grid";
import styled, { spacing } from "@rentiohq/web-theme";

export const RentioLegalOngoingCaseWrapper = styled.div`
  color: ${({ theme }) => theme.colors.warningText};
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: ${spacing("tight")};
`;

export const RentioLegalClosedCasesWrapper = styled.div`
  color: ${({ theme }) => theme.colors.primary[800]};
  border-top: 1px solid lightgrey;
  margin-top: ${spacing("loose")};
  padding-top: ${spacing("base")};
`;

export const RentioLegalClosedCase = styled.div`
  align-items: center;
  display: flex;
  cursor: pointer;
  padding-bottom: ${spacing("tight")};
`;

export const Flex = styled(FlexBase)`
  gap: 16px;
`;
